import { render, staticRenderFns } from "./AnnotationCard.vue?vue&type=template&id=65a6cda0&scoped=true&"
import script from "./AnnotationCard.vue?vue&type=script&lang=js&"
export * from "./AnnotationCard.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationCard.vue?vue&type=style&index=0&id=65a6cda0&prod&lang=scss&"
import style1 from "./AnnotationCard.vue?vue&type=style&index=1&id=65a6cda0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a6cda0",
  null
  
)

export default component.exports